// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"6039dfe0","795":"bcd0138f"}[chunkId] + ".chunk.js";
};